<h2 mat-dialog-title>{{ 'Address.Title' | translate }}</h2>
<mat-dialog-content>
    <sl-address [(address)]="data.address" [isDisabled]="false" />
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{ 'General.Cancel' | translate }}</button>
    <button mat-button (click)="onSave()" color="primary">{{ 'General.Save' | translate }}</button>
</mat-dialog-actions>
